var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/pro-regular-svg-icons";
import Input from "@mui/joy/Input";
import ChartTypeSelector from "../../home/chart/chartTypeSelector";
import { Select, Option } from "@mui/joy";
export var ReportsChartTabItem = function (_a) {
    var _b;
    var module = _a.module, fieldName = _a.fieldName, index = _a.index, updateSettings = _a.updateSettings, _c = _a.meta, meta = _c === void 0 ? {} : _c, record = _a.record, _d = _a.fieldValues, fieldValues = _d === void 0 ? [] : _d;
    var initialSettings = (_b = {},
        _b["aor_chart_id[".concat(index, "]")] = meta.id || "",
        _b["aor_chart_type[".concat(index, "]")] = meta.type,
        _b["aor_chart_title[".concat(index, "]")] = meta.name,
        _b["aor_chart_x_field[".concat(index, "]")] = meta.x_field,
        _b["aor_chart_y_field[".concat(index, "]")] = meta.y_field,
        _b);
    var _e = useState(initialSettings), settings = _e[0], setSettings = _e[1];
    var _f = useState(false), isRemoved = _f[0], setRemoved = _f[1];
    var test = [];
    useEffect(function () {
        updateSettings(index, settings); // ✅ nouveau format
    }, [settings]);
    var removeIndex = function (index) {
        var _a;
        setSettings(__assign(__assign({}, settings), (_a = {}, _a["aor_chart_id[".concat(index, "]")] = "-1", _a["aor_chart_title[".concat(index, "]")] = "-1", _a["aor_chart_type[".concat(index, "]")] = "-1", _a["aor_chart_x_field[".concat(index, "]")] = "-1", _a["aor_chart_y_field[".concat(index, "]")] = "-1", _a)));
    };
    return (_jsx(_Fragment, { children: fieldName && (_jsxs("tr", __assign({ className: "w-full", style: { display: isRemoved ? "none" : "" } }, { children: [_jsx("td", __assign({ title: "Supprimer" }, { children: _jsx(FontAwesomeIcon, { icon: faTrash, className: "text-red-400 cursor-pointer", onClick: function () {
                            removeIndex(index);
                            setRemoved(true);
                        } }) })), _jsx("td", { children: _jsx(Input, { type: "text", name: "name", className: "border border-gray-300 rounded-md p-1", value: settings["aor_chart_title[".concat(index, "]")], onChange: function (e) {
                            var _a;
                            setSettings(__assign(__assign({}, settings), (_a = {}, _a["aor_chart_title[".concat(index, "]")] = e.target.value, _a)));
                        } }) }), _jsx("td", { children: _jsx(ChartTypeSelector, { value: settings["aor_chart_type[".concat(index, "]")] || "", onChange: function (value) {
                            var _a;
                            setSettings(__assign(__assign({}, settings), (_a = {}, _a["aor_chart_type[".concat(index, "]")] = value, _a)));
                        } }) }), _jsx("td", { children: _jsx(Select, __assign({ size: "sm", className: "w-full", defaultValue: parseInt(settings["aor_chart_x_field[".concat(index, "]")]), value: parseInt(settings["aor_chart_x_field[".concat(index, "]")]), onChange: function (event, value) {
                            var _a;
                            setSettings(__assign(__assign({}, settings), (_a = {}, _a["aor_chart_x_field[".concat(index, "]")] = value, _a)));
                        } }, { children: fieldValues &&
                            Object.entries(fieldValues).map(function (item, index) { return (_jsx(Option, __assign({ value: index }, { children: item[1] }), index)); }) })) }), _jsx("td", { children: _jsx(Select, __assign({ size: "sm", className: "w-full", defaultValue: parseInt(settings["aor_chart_y_field[".concat(index, "]")]), value: parseInt(settings["aor_chart_y_field[".concat(index, "]")]), onChange: function (event, value) {
                            var _a;
                            setSettings(__assign(__assign({}, settings), (_a = {}, _a["aor_chart_y_field[".concat(index, "]")] = value, _a)));
                        } }, { children: fieldValues &&
                            Object.entries(fieldValues).map(function (item, index) { return (_jsx(Option, __assign({ value: index }, { children: item[1] }), index)); }) })) })] }))) }));
};
